import React from 'react'
import { toTitleCase } from '../../utils/textFormatting'
import './DeleteConfirmModal.scss'

interface DeleteConfirmModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  jobTitle?: string
  isDeleting: boolean
}

function DeleteConfirmModal({ isOpen, onClose, onConfirm, jobTitle, isDeleting }: DeleteConfirmModalProps) {
  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="delete-modal-content">
        <div className="delete-modal-header">
          <div className="delete-modal-icon">🗑️</div>
          <h3 className="delete-modal-title">Delete Job Posting?</h3>
        </div>

        <div className="delete-modal-body">
          <p>
            Are you sure you want to delete <strong>{toTitleCase(jobTitle) || 'this job posting'}</strong>? 
            This action cannot be undone.
          </p>
        </div>

        <div className="delete-modal-footer">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteConfirmModal
